import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../components/elements/toast/toast.service';
import { AuthenticationService } from '../shared/services/authentication/authentication.service';
import { ModerationService } from '../shared/services/http-services/Auth/moderation.service';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  public loginForm!: UntypedFormGroup;
  public submitted: boolean = false;
  public processingRequest: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private moderationService: ModerationService,
    public toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required]
    })

    console.log("wesel hena")

  }

  get loginFormControl() {
    return this.loginForm.controls;
  }

  Submit() {
    this.processingRequest = true;
    const loginModel = {
      userName: this.loginForm.value.username,
      password: this.loginForm.value.password
    };

    this.moderationService.login(loginModel).subscribe((res: any) => {
      this.processingRequest = false;
      this.loginForm.disable;
      this.toastService.show('Thanks ! We are Preparing your account..', { classname: 'bg-success text-light', delay: 15000 });
      this.authService.setToken(res.data.token, res.data.refreshToken);
 

      setTimeout(() => {
        this.toastService.toasts = [];
        this.router.navigate(['./dashboard']);
      }, 300);
    }, error => {
      console.log(error);
      this.toastService.showError(error);
      this.processingRequest = false;
    });
  }
  
  inputType: string = "password";
  pView: string = "-slash";
  viewPassword() {
    if (this.inputType != 'text') {
      this.inputType = 'text';
      this.pView = "";
    }
    else {
      this.inputType = 'password';
      this.pView = "-slash";

    }
  }

}
